//
// Code complete for args.data (operator, 14.10.2026).
//
// global.d.ts types the row as `data: any[]`, so the editor had nothing to
// suggest. It now reads `data: ConverterData`, an interface open to any key;
// each converter adds its own fields and join projections to it when its
// editor opens, and again when the query builder or the columns change.
// Nothing of it is stored: it is made from the mapping each time.
//
// global.ts itself stays as it is — on the servers it sits in a bind mount and
// would have to be copied by hand. The change is made to the text the editor
// loads.
//

/** Where the declaration of the open converter lives in the editor. */
export const CONVERTER_DATA_LIB = 'file:///converter-data.d.ts'

const quote = (key: string) => `'${key.replace(/\\/g, '\\\\').replace(/'/g, "\\'")}'`

/** The fields of a converter as members of ConverterData: suggested, not required. */
export function converterDataDeclaration(fields: string[]): string {
    const keys = [...new Set(fields.filter((field) => typeof field === 'string' && field !== ''))]
    return [
        'declare interface ConverterData {',
        ...keys.map((key) => `    ${quote(key)}?: any;`),
        // whatever is not known stays allowed: no red in existing code
        '    [key: string]: any;',
        '}',
        '',
    ].join('\n')
}

/**
 * global.d.ts with args.data typed as ConverterData. Only the data member of
 * ConverterProps is touched; a text without it is returned unchanged.
 */
export function withConverterData(globalDts: string): string {
    const props = /(declare type ConverterProps = \{[^}]*?\n\s*data:\s*)any\[\];/
    if (!props.test(globalDts)) return globalDts
    return (
        globalDts.replace(props, '$1ConverterData;') +
        '\ndeclare interface ConverterData {\n    [key: string]: any;\n}\n'
    )
}
